import React from 'react';

import './style.scss';

const Text = (props) => {
  const { style, text } = props;

  return (
    <p className='text' style={{ ...style }}>
      {text}
    </p>
  );
};

export default Text;
